import { clickActionsSnippet } from './click-actions.snippet';
import { localeLinkSnippet } from './locale-link.snippet';
import { richDetailsSnippet } from './rich-details.snippet';
import type { Snippet } from './types/Snippet';

const snippets: Snippet[] = [
  richDetailsSnippet,
  clickActionsSnippet,
  localeLinkSnippet,
];

export function bootstrapSnippets() {
  document.addEventListener('click', (event) => {
    const { target } = event;
    if (!(target instanceof Element)) return;

    snippets.forEach((snippet) => {
      snippet.click?.(target, event);
    });
  });

  document.addEventListener('pointerover', (event) => {
    const { target } = event;
    if (!(target instanceof Element)) return;

    snippets.forEach((snippet) => {
      snippet.pointerover?.(target, event);
    });
  });

  document.addEventListener(
    'toggle',
    (event) => {
      const { target } = event;
      if (!(target instanceof Element)) return;

      snippets.forEach((snippet) => {
        snippet.toggle?.(target, event);
      });
    },
    true,
  );

  snippets.forEach((snippet) => {
    snippet.init?.();
  });
}
